
(function () {
    "use strict"

    angular.module('formApp')

        // directive to set the focus to the input field
        .directive('compile',
            [
                '$compile', function ($compile) {
                    return function (scope, element, attrs) {
                        scope.$watch(
                            function (scope) {
                                return scope.$eval(attrs.compile);
                            },
                            function (value) {
                                element.html(value);
                                $compile(element.contents())(scope);
                            }
                        )
                    }
                }
            ])
        .directive('focusMe',
            [
                '$timeout', '$parse', function ($timeout, $parse) {
                    return {
                        link: function (scope, element, attrs) {
                            var model = $parse(attrs.focusMe);
                            scope.$watch(model,
                                function (value) {
                                    if (value === true) {
                                        $timeout(function () {
                                            element[0].focus();
                                        });
                                    }
                                });
                        }
                    };
                }
            ])
        // directive to ensure that onfocusout / onblur validation fires before the next event is triggered.
        .directive('validationClick',
            [
                '$timeout', function ($timeout) {
                    return function (scope, element, attrs) {
                        element.bind("keydown keypress mouseup",
                            function (event) {
                                if ((event.which === 13 && event.type === "keydown") ||
                                    (event.type === "mouseup" && event.which !== 3) ||
                                    event.type === "click") {
                                    // Current onfocusout timeout is 50ms. This just needs to be more than that.
                                    setTimeout(function () {
                                        scope.$apply(function () { scope.$eval(attrs.validationClick); });
                                    },
                                        60);
                                }
                            });
                    };
                }
            ])
        //directive to call the google api for address and custom logic for address validation
        .directive('address',
            [
                function () {
                    return {
                        require: 'ngModel',
                        scope: {
                            callbackFn: '&',
                            ngModel: '='
                        },
                        link: function (scope, element, attrs, model) {

                            var options = {
                                types: ['address'],
                                componentRestrictions: { country: "au" },
                            };
                            scope.gPlace = new google.maps.places.Autocomplete(element[0], options);
                            var addressElementArray = '';
                            var pIndex, sCode, sIndex, qCode, pageId, navNum;
                            element.on('change',
                                function (element, attrs) {
                                    var addressElementArray = element.currentTarget.id.split('-');
                                    if (scope.$parent.navTab &&
                                        scope.$parent.page &&
                                        scope.$parent.navTab.number &&
                                        scope.$parent.page.number) {

                                        var responseId = scope.$parent.navTab.number + '-' + scope.$parent.page.number;
                                        if (addressElementArray.length === 4) {
                                            pIndex = addressElementArray[0];
                                            sCode = addressElementArray[1];
                                            sIndex = addressElementArray[2];
                                            qCode = addressElementArray[3];
                                            var question = { code: qCode };
                                            scope.$parent.responses[responseId][pIndex][sCode][sIndex][qCode + '-valid'
                                            ] = false;
                                            scope.$parent.utility.removeFromValidationErrors(null,
                                                responseId,
                                                pIndex,
                                                sCode,
                                                sIndex,
                                                qCode);
                                            element.currentTarget.setAttribute('aria-invalid', 'true');
                                        }
                                    }
                                });
                            var updatePlace = function () {
                                var addressArray = null;
                                var pIndex, sCode, sIndex, qCode, navNum;

                                if (scope.gPlace &&
                                    scope.gPlace.getPlace() &&
                                    scope.gPlace.getPlace().address_components) {

                                    if (scope.$parent.navTab && scope.$parent.page) {
                                        var responseId = scope.$parent.navTab.number + '-' + scope.$parent.page.number;
                                    }
                                    var addressElementArray = element[0].id.split('-');
                                    if (addressElementArray.length === 4) {
                                        pIndex = addressElementArray[0];
                                        sCode = addressElementArray[1];
                                        sIndex = addressElementArray[2];
                                        qCode = addressElementArray[3];
                                        scope.$parent.responses[responseId][pIndex][sCode][sIndex][qCode + '-valid'] =
                                            true;
                                        var question = { code: qCode };

                                        scope.$parent.utility.removeFromValidationErrors(null,
                                            responseId,
                                            pIndex,
                                            sCode,
                                            sIndex,
                                            qCode);
                                        element[0].setAttribute('aria-invalid', 'false');
                                    }
                                    addressArray = scope.gPlace.getPlace().address_components;
                                }
                                scope.$apply(function () {
                                    model.$setViewValue(element.val());
                                    scope.callbackFn({
                                        arg1: addressArray
                                    });
                                });
                            }
                            google.maps.event.addListener(scope.gPlace, 'place_changed', updatePlace);
                        }
                    };
                }
            ])
        .directive('changeOnKeyup',
            [
                function () {
                    return function changeOnKeyupPostLink(scope, elem) {
                        elem.on('keyup', elem.triggerHandler.bind(elem, 'change'));
                    };
                }
            ])
        // directive to trigger enter key stroke on any element
        .directive('onFocusOut',
            [
                function () {
                    return {
                        scope: {
                            focusOutCallback: '&'
                        },
                        link: function (scope, elem, attrs) {
                            $(elem).focusout(function () {
                                setTimeout(function () {
                                    var newFocus = $("*:focus").attr("id");
                                    if (!newFocus || newFocus.indexOf(attrs.focusOutId) < 0) {
                                        scope.$apply(function () {
                                            scope.focusOutCallback();
                                        });
                                    }
                                },
                                    50);
                            });
                        }
                    }
                }
            ])
        .directive('ngEnter',
            function () {
                return {
                    scope: {
                        callbackFn: '&'
                    },
                    link: function (scope, element, attrs) {
                        element.bind("keypress",
                            function (event) {
                                if (event.which === 13) {
                                    scope.$apply(function () {
                                        scope.callbackFn();
                                    });
                                    event.preventDefault();
                                }
                            });
                    }
                }
            })
        //this directive handles non numeric vales entered by the user for input types that expect a numric value
        .directive('filterInputType',
            function () {
                return {
                    require: 'ngModel',
                    link: function (scope, element, attrs, modelCtrl) {
                        if (attrs.filterInputType == "number") {
                            modelCtrl.$parsers.push(function (inputValue) {
                                if (!isNaN(parseFloat(inputValue)) && (isFinite(inputValue))) {
                                    return parseFloat(inputValue);
                                } else {
                                    return inputValue;
                                }
                            });
                        }
                    }
                };
            })
        //this directive handles address related validation error when address is entered manually
        .directive('resetAddressErrors',
            function () {
                return {
                    require: 'ngModel',
                    link: function (scope, element, attrs, modelCtrl) {
                        if (attrs.resetAddressErrors) {
                            element.on('change',
                                function (element, attrs) {
                                    if (element.currentTarget &&
                                        element.currentTarget.getAttribute("reset-address-errors")) {
                                        var manualAddress =
                                            JSON.parse(element.currentTarget.getAttribute("reset-address-errors")
                                                .replace(/'/g, '"'));
                                        var addressElementArray = element.currentTarget.id.split('-');
                                        if (scope.$parent.navTab &&
                                            scope.$parent.page &&
                                            scope.$parent.navTab.number &&
                                            scope.$parent.page.number) {
                                            var pIndex, sCode, sIndex, qCode, pageId, navNum;
                                            if (addressElementArray.length === 4) {
                                                pIndex = addressElementArray[0];
                                                sCode = addressElementArray[1];
                                                sIndex = addressElementArray[2];

                                                var responseId =
                                                    scope.$parent.navTab.number + '-' + scope.$parent.page.number;
                                                if (addressElementArray.length === 4) {
                                                    if (manualAddress.suburb) {
                                                        scope.$parent.utility.removeFromValidationErrors(null,
                                                            responseId,
                                                            pIndex,
                                                            sCode,
                                                            sIndex,
                                                            manualAddress.suburb);
                                                    }
                                                    if (manualAddress.state) {
                                                        scope.$parent.utility.removeFromValidationErrors(null,
                                                            responseId,
                                                            pIndex,
                                                            sCode,
                                                            sIndex,
                                                            manualAddress.state);
                                                    }
                                                    if (manualAddress.streetNumberName) {
                                                        scope.$parent.utility.removeFromValidationErrors(null,
                                                            responseId,
                                                            pIndex,
                                                            sCode,
                                                            sIndex,
                                                            manualAddress.streetNumberName);
                                                    }
                                                    if (manualAddress.postCode) {
                                                        scope.$parent.utility.removeFromValidationErrors(null,
                                                            responseId,
                                                            pIndex,
                                                            sCode,
                                                            sIndex,
                                                            manualAddress.postCode);
                                                    }
                                                }
                                            }
                                        }
                                    }
                                });
                        }
                    }
                };
            })
        //this directive caters to ng touch event for ipad and mobile devices for browsing the applications on manage apps screen
        .directive("ngTouchend",
            function () {
                return {
                    controller: [
                        "$scope", "$element", function ($scope, $element) {

                            $element.bind("touchend", onTouchEnd);

                            function onTouchEnd(event) {
                                var method = $element.attr("ng-touchend");
                                $scope.$event = event;
                                $scope.$apply(method);
                            }
                        }
                    ]
                }
            })
        .directive('fastOptions',
            function () {
                return {
                    restrict: 'A',
                    require: 'ngModel',
                    transclude: true,
                    link: function (scope, element, attrs, cntrller, transcludeFn) {
                        var expression = attrs.fastOptions;

                        var parts = expression.split(';').map(function (part) { return part.trim(); });

                        // We must have at least the data, value and label to proceed
                        if (parts.length < 3) {
                            throw new Error(
                                'Expected expression of type: data; value = Id; label = Name; <defaultValue> = \'text\'. But got: ' +
                                expression);
                        }

                        // value
                        var valueParts = parts[1].split('=').map(function (subPart) { return subPart.trim(); });
                        if (valueParts.length !== 2) {
                            throw new Error('Incorrect value. Expected expression of type: value = Id. But got: ' +
                                parts[1]);
                        }
                        var valueExpression = valueParts[1];

                        // label
                        var labelParts = parts[2].split('=').map(function (subPart) { return subPart.trim(); });
                        if (labelParts.length !== 2) {
                            throw new Error('Incorrect label. Expected expression of type: label = Name. But got: ' +
                                parts[2]);
                        }
                        var labelExpression = labelParts[1];

                        // defaultValue
                        var defaultValueExpression;
                        if (parts.length > 3) {
                            var defaultValueParts = parts[3].split('=')
                                .map(function (subPart) { return subPart.trim(); });
                            if (defaultValueParts.length !== 2 &&
                                defaultValueParts[1].indexOf('\'') == 0 &&
                                defaultValueParts[1].lastIndexOf('\'') == defaultValueParts[1].length - 1) {
                                throw new Error(
                                    'Incorrect defaultValue. Expected expression of type: defaultValue = \'text\'. But got: ' +
                                    parts[3]);
                            }
                            defaultValueExpression = defaultValueParts[1].substring(1, defaultValueParts[1].length - 1);
                        }

                        var collectionKey = parts[0];

                        scope.$watchCollection(collectionKey,
                            function (collection) {

                                transcludeFn(function (clone) {
                                    element.append(clone);
                                });

                                var selectedValue = scope.$eval(attrs.ngModel) || '';

                                var allOptions = '';
                                var showDefaultOption = defaultValueExpression != undefined;
                                _.forEach(collection,
                                    function (collectionItem) {

                                        var value = collectionItem[valueExpression];
                                        var label = collectionItem[labelExpression];

                                        var selectedHtml = '';
                                        if (value == selectedValue) {
                                            selectedHtml = 'selected="selected"';
                                            showDefaultOption = false; // option is selected, hide default.
                                        }
                                        var optionHtml = '<option value="' +
                                            value +
                                            '" label="' +
                                            label +
                                            '" ' +
                                            selectedHtml +
                                            '>' +
                                            label +
                                            '</option>';

                                        allOptions += optionHtml;
                                    });
                                if (showDefaultOption) {
                                    allOptions = '<option value="" label="' +
                                        defaultValueExpression +
                                        '">' +
                                        defaultValueExpression +
                                        '</option>' +
                                        allOptions;
                                }

                                // as the options are added after the model may be already bound, 
                                // we need to remove the blank option that angular automatically adds
                                var possibleBlankEntry = element.children().first();
                                var value = possibleBlankEntry.val();
                                if (value.indexOf('?') == 0 && value.lastIndexOf('?') == value.length - 1) {
                                    possibleBlankEntry.remove();
                                }
                                element.append(allOptions);
                            });
                    }
                };
            })
        .directive('themeLoader', ['departmentTheme', function (departmentTheme) {
            return {
                link: function (scope, element, attrs) {
                    // Load the theme CSS dynamically based on the path
                    var bodyTag = angular.element(document.querySelector('body'));

                    if (departmentTheme.isDHVisible) {
                        bodyTag.addClass("dhTheme");
                    }
                    else if (departmentTheme.isDFFHVisible) {
                        bodyTag.addClass("dffhTheme");
                    } else {
                        if (window.location.href.indexOf("id_token") > -1) {
                            var adalRequest = sessionStorage.getItem("adal.login.request");
                            if (adalRequest && adalRequest.indexOf("DH") > -1) {
                                bodyTag.addClass("dhTheme");
                            }
                            else if (adalRequest && adalRequest.indexOf("DFFH") > -1) {
                                bodyTag.addClass("dffhTheme");
                            }
                            else
                                bodyTag.addClass("standardTheme");

                        }
                        else
                            bodyTag.addClass("standardTheme");
                    }
                }
            };
        }])
}
    ());
